import { Component } from '@angular/core';

@Component({
	selector: 'ansyn-cases',
	templateUrl: './cases.component.html',
	styleUrls: ['./cases.component.less']
})

export class CasesComponent {
}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/cases/components/cases/cases.component.ts